var InfoModal = class extends HTMLElement {
  constructor() {
    super()


    this.attachShadow({ mode: 'open' });

    const template = document.createElement("div");
    template.classList.add('vehiclePicker__selects');

    template.addEventListener(
      'click',
      (ev)=> {
          ev.stopPropagation();
      }
    );


    this.shadowRoot.innerHTML = `
    <style>
    h5{
      margin-bottom: 0px;
    }

    .infoModal__modalContent {
      padding: 30px;
    }

    .infoModal__modalContent::-webkit-scrollbar {
      -webkit-appearance: none;
      display: none;
      height: 7px;
      width: 7px;
    }

    .infoModal__modalContent::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
    }

    .close{
      color: var(--light-grey);
      position: absolute;
      top: var(--spacing-7-5);
      right: var(--spacing-7-5);
    }

    .infoModal__container.on{
      display: block;
    }

    .infoModal__container{
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
      padding: var(--spacing-5);
      box-sizing: border-box;
      background-color: rgba(0,0,0, .5);
    }

    .infoModal__modal{
      position: absolute;
      top: 50%;
      left: 50%;
      border: 1px solid #CBCBCC;
      display: block;
      width: calc(100vw - var(--spacing-10));
      box-sizing: border-box;
      background-color: var(--white);
      opacity: 0;
      transform: translate(-50%, -50%);
      transition: transform 0.4s, opacity 0.4s;
    }

    .infoModal__modal.opened{
      opacity: 1;
      max-height: 75vh;
      overflow-y: scroll;
    }

    .vehiclePicker__container{
      display: none;
      position: fixed;
      background-color: rgba(0,0,0,.5);
      width: 100%;
      top: 0;
      height: 100%;
      left: 0;
      z-index: -10;
      padding-top: 50px;
    }

    .infoModal__container.opened{
      display: flex;
      z-index: 99;
    }

    .infoModal__modalContent img{
      max-width: 100%;
    }


    select{
      width: 100%;
    }

    @media only screen and (min-width: 700px){
      .infoModal__container{
        padding: 0;
      }

      .infoModal__modalContent {
        padding: 60px;
      }

      .infoModal__modal{
        position: absolute;
        width: 560px;
        max-width: 90%;
      }
    }


    </style>
    `;


    this.$close = document.createElement('a');
    this.$close.classList.add('close');
    this.$close.setAttribute('href', '#');
    // this.$close.innerHTML = '<svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="" viewBox="0 0 24 24"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path></svg>';
    this.$close.innerHTML = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L21 21" stroke="currentColor" stroke-width="2"/><path d="M21 1L1 21" stroke="currentColor" stroke-width="2"/></svg>';
    this.$close.addEventListener('click', (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        this.close();
        return false;
      })



    this.$container = document.createElement("div");
    this.$modal = document.createElement("div");
    this.$modalContent = document.createElement("div");

    this.$container.classList.add('infoModal__container');
    this.$modal.classList.add('infoModal__modal');
    this.$modalContent.classList.add('infoModal__modalContent');

    this.$modal.appendChild(this.$close);
    this.$modal.appendChild(this.$modalContent);
    this.$container.appendChild(this.$modal);
    this.shadowRoot.appendChild(this.$container);


    this.$container.addEventListener(
      'click',
      ()=> {
          this.close();
      }
    );

    this.$modal.addEventListener(
      'click',
      (ev)=> {
          ev.stopPropagation();
      }
    );

    // Add a click event listener to the button to toggle the section's visibility
    //button.addEventListener('click', () => {
    //  section.style.display = section.style.display === 'none' ? 'block' : 'none';
    //});


  }




  open(){
    this.shadowRoot.querySelector('.infoModal__container').classList.add(`opened`)
    setTimeout(() => {
      this.shadowRoot.querySelector('.infoModal__modal').classList.add(`opened`)
    }, 100);
    document.querySelector('html').classList.add('lock');
    // this.shadowRoot.querySelector('div.vehiclePicker__selects').style.display = 'block';
  }

  close(){
    this.shadowRoot.querySelector('.infoModal__modal').classList.remove(`opened`)
    document.querySelector('html').classList.remove('lock');
    setTimeout(() => {
      this.$container.classList.remove(`opened`);
    }, 400);
  }

  loadRemoteContent(url){

    this.shadowRoot.querySelector('.infoModal__modalContent').innerHTML = '';

	fetch(url).then(res=>res.json()).then(
		res=>{

			this.shadowRoot.querySelector('.infoModal__modalContent').innerHTML = res.page.body_html;
			//this.shadowinnerHMTL = `<h2>${res.page.title}</h2><p>${res.page.html_content}</p>`;

		}
	)

	//

}



};

if (!window.customElements.get("info-modal")) {
  window.customElements.define("info-modal", InfoModal);
}
